import React, {useRef} from 'react';
import Autosuggest from 'react-autosuggest';
import Chip from './Chip';
import './searchTheme.css';
import {withRouter} from 'react-router-dom'
import {connect} from "react-redux";
import Search from "../Modal/Search";
import SVG from 'react-inlinesvg';
import searchIcon from '../../assets/icons/search1.svg';
import arrow from '../../assets/chevron-right-solid.svg';

import {
    fetchSearchData,
    fetchSearchResults,
    addSearchChip,
    removeLastChip,
    removeSearchChip,
    clearSearchFilter, getFilter
} from "../../actions/searchActions";
import caretDown from "../../assets/caret-down.svg";
import queryString from "query-string";

class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            value: '',
            chips: [],
            chipSelected: false,
            uniqueChip: true,
            clear: false,
            suggestions: [],
            searchQuery: false,
            showModal: {
                search: false,
                dropDownModal: false
            },
            show: false,
            search_term: "",
            label_text: "All Creatives",
            searchObj :{
                allCreatives: true,
                mockUps: false,
                liveUnits: false,
                any: false
            }
        };
        this.wrapperRef = React.createRef();
        this.innerRef = React.createRef();
        this.modal = React.createRef();
        this.main = React.createRef();
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal(show, key) {
        let parent = this.modal.current.parentNode;
        if(show){
            parent.style.transform = "";
            parent.style.transition = 'all 100ms ease-out 0s';
            document.body.style.overflow = "hidden";
        }else{
            parent.style.transition = 'all 500ms ease-out 0s';
            document.body.style.overflow = "initial";
        }
        this.setState({
            showModal: {
                [key] : show
            }
        })
    }

    componentDidMount() {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let mock = false;
        let live = false;
        let allCreatives = true;
        for (let prop in queryParams) {
            if(prop === "unit_type[]"){
                if(queryParams[prop] === "Live Unit" && queryParams[prop] !== "Mock Unit" ){
                    live = true;
                    mock = false;
                    allCreatives = false;
                }
                if(queryParams[prop] === "Mock Unit" && queryParams[prop] !== "Live Unit"){
                    mock = true;
                    live = false;
                    allCreatives = false;
                }
                if (queryParams[prop] === "Mock Unit" && queryParams[prop] === "Live Unit"){
                    allCreatives = true;
                    live = false;
                    mock = false;
                }
            }
        }
        document.addEventListener("mousedown", this.handleClickOutside);
        this.setState({
            searchObj:{
                ...this.state.searchObj,
                mockUps: mock,
                liveUnits: live,
                allCreatives,
                any: queryParams.any === 'true' ? true : false
            }
        })

        this.props.dispatch(fetchSearchData());
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let path =  this.props.location.pathname;
        if(this.props.location.pathname !== prevProps.location.pathname){
            if(path === "/"){
                this.setState({
                    searchObj :{
                        allCreatives: true,
                        mockUps: false,
                        liveUnits: false,
                        any: false
                    },
                    show: false
                })
            }
            if(path !== "/search"){
                this.setState({
                    searchObj :{
                        allCreatives: true,
                        mockUps: false,
                        liveUnits: false,
                        any: false
                    },
                    show: false
                })
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = (event) => {
        if (!this.main.current.contains(event.target) && this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.innerRef && !this.innerRef.current.contains(event.target)) {
            this.setState({
                show: false,
            })
        }
    }

    getSuggestions = (value) => {
        const escapedValue = value.normalize('NFD').toLowerCase().trim().replace(/[\u0300-\u036f]/g, "");
        if (escapedValue === '') {
            return [];
        }

        return this.props.searchObject
            .map(section => {
                return {
                    title: section.title,
                    options: section.options.filter(option => {
                        if(escapedValue.includes('microsite')){
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true || section.title === 'Campaign Microsite'
                        }
                        if(escapedValue.includes('ar')){
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true || option.name === 'Augmented Reality'
                        }
                        if(escapedValue.includes('rich')){
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true || section.title === 'Creative Live Subtype'
                        }
                        if(escapedValue.includes('ctv')){
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true || option.name === 'Connected TV'
                        }
                        if(escapedValue.includes('dooh')){
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true || option.name === 'Digital Out Of Home'
                        } else{
                            return option.name.normalize('NFD').toLowerCase().replace(/[\u0300-\u036f]/g, "").includes(escapedValue) === true
                        }
                    })
                };
            }).filter(section => section.options.length > 0);
    }

    getSuggestionValue = (suggestion) => {
        return suggestion.name;
    };

    renderSuggestion = (suggestion) => {
        return (
            <span>{suggestion.name}</span>
        );
    };

    renderSectionTitle = (section) => {
        return (
            <strong>{section.title}</strong>
        );
    };

    getSectionSuggestions = (section) => {
        return section.options;
    };

    handleKeyDown = e => {
        if (e.keyCode === 8) {
            this.onBackspace();
        }
        if (e.keyCode === 13 && e.target.value.length === 0) {
            this.handleClick();
        }
    };

    onBackspace = () => {
        if (this.state.value === "" && this.props.chips.length > 0) {
            // this.props.dispatch(getFilter(preSetArray));
            this.props.dispatch(removeLastChip())
        }
    };

    onChange = (e, {newValue, method}) => {
        this.setState({value: newValue})
    };

    componentWillReceiveProps(props) {
        if (props.clear !== this.props.clear) {
            this.setState({
                chips: []
            })
        }
    }

    onSuggestionSelected = (e, {suggestion}) => {
        if(suggestion.type === 'unit_type'){
            let live = suggestion.name === "Live Unit" ? true : false;
            let mock = suggestion.name === "Mock Unit" ? true : false;
            let all =  mock && live ? true : false;
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    allCreatives: all,
                    mockUps: mock,
                    liveUnits: live,
                },
                value: ''
            })

        }else{
            this.props.dispatch(addSearchChip(suggestion));
            this.setState({value: ''})
        }
    };

    onSuggestionsFetchRequested = ({value}) => {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    addChip = (value) => {
        if (this.state.chips.indexOf(value) !== -1) {
            this.setState({value: ""});
            return;
        }
        let newChips = [...this.state.chips]

        this.setState({
            chips: [...newChips, value],
            value: ""
        }, () => {
        })
    }

    removeChip = idx => {
        this.props.dispatch(removeSearchChip(idx))
    };

    //===============================================//
    /*This function is looping through this.state.chips and rendering the chips on the page. */
    //===============================================//
    renderChips = () => {
        return this.props.chips.map((chip, idx) => {
            return (
                <Chip onRemove={this.removeChip} key={idx} index={idx}>{chip.name}</Chip>
            )
        })
    };

    //===============================================//
    /*This function is the onClick function for submitting search results. */
    //===============================================//
    handleClick = () => {
        let chips = this.props.chips;
        let urlProps = this.props.location.search;
        let queryParams = queryString.parse(urlProps);
        let searchOptions = [];
        let obj = {};
        let searchKeys = [];
        let setValues = [];
        let preSetArray = [];
        let searchObj = {};
        let allCreatives = this.state.searchObj.allCreatives;
        let any = "any="+ this.state.searchObj.any;
        searchOptions.push(any)
        if(!preSetArray.includes({type: "any", name: this.state.searchObj.any})){
            preSetArray.push({type: "any", name: this.state.searchObj.any})
        }
        for (let i in chips) {
            let option = chips[i];
            preSetArray.push(option)
            searchOptions.push(option.type + '[]=' + encodeURIComponent(option.name).replace(/\s+/g, '+'));
        }
        for (const qp in queryParams) {
            let value = qp.replace('[]', '');
            let query = queryParams[qp];
            if(value === "to_date_format" || value === "from_date_format"){
                searchOptions.push(value + '[]=' + encodeURIComponent(query).replace(/\s+/g, '+'));
            }
        }
        if(allCreatives){
            let objArr = [
                {
                    type: "unit_type",
                    name: "Mock Unit"
                },
                {
                    type: "unit_type",
                    name: "Live Unit"
                }
            ]
            preSetArray = [...objArr, ...preSetArray];
            for (const objArrKey in objArr) {
                let obj = objArr[objArrKey];
                searchOptions.push(obj.type + '[]=' + encodeURIComponent(obj.name).replace(/\s+/g, '+'))
            }
        }else if(this.state.searchObj.mockUps){
            searchKeys = [...searchKeys, "Mock Unit"]
            searchObj['unit_type'] = searchKeys;
            setValues.push(searchObj);
            obj = {
                type: "unit_type",
                name: "Mock Unit"
            }
            if(!preSetArray.includes(obj)){
                preSetArray.push(obj);
            }
            searchOptions.push(obj.type + '[]=' + encodeURIComponent(obj.name).replace(/\s+/g, '+'))
        }else if(this.state.searchObj.liveUnits){
            obj = {
                type: "unit_type",
                name: "Live Unit"
            }
            if(!preSetArray.includes(obj)){
                preSetArray.push(obj);
            }
            searchOptions.push(obj.type + '[]=' + encodeURIComponent(obj.name).replace(/\s+/g, '+'))
        }
        this.props.history.push(`/search?${searchOptions.join('&')}`);
        this.props.dispatch(clearSearchFilter());
        this.props.dispatch(fetchSearchResults(1, searchOptions));
        this.props.dispatch(getFilter(preSetArray));
        this.props.dispatch(fetchSearchData());
    };

    clearChips = () => {
        if (this.props.clear) {
            this.setState({
                chips: []
            })
        }
    };
    changeClass =  () => {
        this.setState({
            show: !this.state.show
        })
    }
    // onSelectChange = (e) => {
    //     this.setState({
    //         searchObj: {
    //             ...this.state.searchObj,
    //             [e.target.id]: e.target.checked
    //         }
    //     })
    // }
    changeText = () => {
        const {searchObj} = this.state;
        let text = "All Creatives";
        if(searchObj.mockUps){
            text = "Mockups"
        }
        if(searchObj.liveUnits){
            text = "Live Units"
        }
        if(searchObj.liveUnits && searchObj.mockUps){
            text = "All Creatives";
        }
        return text
    }
    onRadioChange = (e) => {
        this.setState({
            searchObj: {
                [e.target.id]: e.target.checked,
                any: this.state.searchObj.any
            }
        })
    }
    onToggle = (e) => {
        let choice = false;
        if(e.target.value === "and"){
            choice = true
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                any: choice
            }
        })
    }

    render() {
        const {value, suggestions} = this.state;
        const inputProps = {
            placeholder: "Search here",
            value,
            onChange: this.onChange,
            onKeyDown: this.handleKeyDown
        };
        return (
            <div className={`search-container ${this.props.sticky ? 'sticky-search-bar' : '' }`} ref={this.modal}>
                <div className="search-row">
                    <div className={`main-search-drop-down ${this.state.show ? 'active': ''}`} ref={this.wrapperRef} onClick={() => this.changeClass()}>
                        <span className={`main-span ${this.state.searchObj.liveUnits ? 'live-search' : this.state.searchObj.mockUps ? 'mock-search' : ''}`}>{this.changeText()} <SVG src={arrow} className={this.state.show ? "active": ""}/></span>
                        <div ref={this.innerRef} className={`search--dropdown-menu ${this.state.show ? 'active': ''}`}>
                            <form>
                                <div className="check-container">
                                    <div className="radio-row" style={{backgroundColor: this.state.searchObj.allCreatives ? '#006B81' : '' }}>
                                        <input type="radio" className="hide-radio" id="allCreatives" name="creative-options" checked={this.state.searchObj.allCreatives} onChange={this.onRadioChange}/>
                                        <label htmlFor="allCreatives">All Creatives</label>
                                    </div>
                                    <div className="radio-row" style={{backgroundColor: this.state.searchObj.mockUps ? '#006B81' : '' }}>
                                        <input type="radio" className="hide-radio" id="mockUps" name="creative-options"  checked={this.state.searchObj.mockUps} onChange={this.onRadioChange}/>
                                        <label htmlFor="mockUps">Only Mocks</label>
                                    </div>
                                    <div className="radio-row" style={{backgroundColor: this.state.searchObj.liveUnits ? '#006B81' : '' }}>
                                        <input type="radio" className="hide-radio" id="liveUnits" name="creative-options"  checked={this.state.searchObj.liveUnits} onChange={this.onRadioChange}/>
                                        <label htmlFor="liveUnits">Only Live Units</label>
                                    </div>
                                </div>
                                <div className='radio-container'>
                                    <label>Match Terms:</label>
                                    <div className="toggle-container">
                                        <label><span style={{fontWeight: this.state.searchObj.any ? 'bold' : 'normal'} }>Any</span></label>
                                        <label className="switch">
                                            <input type="checkbox" name="any" value={!this.state.searchObj.any ? "and" : 'or'} checked={!this.state.searchObj.any} onChange={this.onToggle}/>
                                            <span className="slider round" ></span>
                                        </label>
                                        <label><span style={{fontWeight: !this.state.searchObj.any ? 'bold' : 'normal'}}>All</span></label>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                        <div className="main-container" ref={this.main}>
                            <div className="main-container-wrapper">
                        {this.renderChips()}
                        <Autosuggest
                            multiSection={true}
                            suggestions={suggestions}
                            onChange={this.onChange}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            renderSectionTitle={this.renderSectionTitle}
                            getSectionSuggestions={this.getSectionSuggestions}
                            highlightFirstSuggestion={true}
                            inputProps={inputProps}
                            onSuggestionSelected={this.onSuggestionSelected}
                            focusInputOnSuggestionClick={true}
                        />
                    </div>
                    </div>
                    <div className="searchBtn" onClick={this.handleClick}><SVG src={searchIcon} className="search-icon"/></div>
                </div>
                {/*<div className="search-help desktopDisplay">{this.props.sticky ? <span className='sticky-search-help' onClick={e => this.toggleModal(true, 'search')}>What can I search for?</span> : ""}</div>*/}
                <div className="search-help desktopDisplay">{this.props.location.pathname !== '/search' && this.props.location.pathname !== '/' ? <span className='sticky-search-help' onClick={e => this.toggleModal(true, 'search')}>What can I search for?</span> : ""}</div>

                {this.state.showModal.search && <Search
                    toggleModal={this.toggleModal}
                />}
            </div>

        );
    }
}

const mapStateToProps = state => ({
    searchObject: state.search.searchObject,
    chips: state.search.chips
});

export default withRouter(connect(mapStateToProps)(SearchBar));
